import 'pages/PageNotFound404/PageNotFound404.scss';
import useIsPatientVersion from 'app/hooks/useIsPatientVersion';
import { Page } from 'app/types/ProductCatalog';
import { Heading } from 'components/Typography';

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import cn from 'classnames';

const PageNotFound404: React.FC<Page> = ({ setPageHeader }) => {
  const isPatientVersion = useIsPatientVersion();

  useEffect(() => {
    setPageHeader(undefined);
  }, [ setPageHeader ]);

  return (
    <div className="pageNotFound404">

      <Helmet title="404 Not Found" />

      <div className={cn('pageNotFound404__code', { pageNotFound404__code_patients: isPatientVersion })}>
        4<span>0</span>4
      </div>

      <Heading variant="H2">The Page You Requested Could Not Be Found</Heading>
    </div>
  );
};

export default PageNotFound404;
